import ErrorPage from './error-page'

export default function PageNotFoundError() {
  return (
    <ErrorPage title="⚠️ Page Not found">
      We're sorry, but the page you're looking for doesn't exist.
    </ErrorPage>
  )
}
